import React, { ReactNode, useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import {
    Dropdown,
  Image,
  Menu,
  MenuItemProps,
} from "semantic-ui-react";
import { genericMethod, store, Action } from "../store";
import { State } from "../State";
import { NJLOGO } from "../Assets";

// adapted from codesandbox.io/s/y7k3zn5qn1

// tslint:disable-next-line: interface-name
export interface NavBarBaseProps {
    logoSrc: ReactNode;
    title: string;
    leftItems: MenuItemProps[];
    rightItems: MenuItemProps[];
    leftActions: genericMethod[];
    rightActions: genericMethod[];
}

interface Props {
    children: ReactNode;
}

function themeToggle(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, dispatch: React.Dispatch<Action>): void {
    e.preventDefault();
    dispatch({ type: "toggle theme" });
}

function goHome(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
                dispatch: React.Dispatch<Action>,
                s: State): void {
    e.preventDefault();
    dispatch({ type: "clear state" });
    s.appState.history.push("/");
}

const ResponsiveNavbar: React.FunctionComponent<Props> = (props: Props) => {
    const globalState = useContext(store);
    const { dispatch, state } = globalState;

    return (
        (globalState.state.appState.isNavbarVisible &&
        <div>
            <Menu fixed="top" style={{
                boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.2)",
            }} borderless stackable inverted={globalState.state.appState.isDarkTheme}>
                <Menu.Item as={Link} to={"/"} icon active={undefined} onClick={(e) => goHome(e, dispatch, state)}>
                    <Image centered size="mini" children={NJLOGO}/>
                    </Menu.Item>
                    <Menu.Item fitted="vertically" header>
                    <h1>Workers Comp Inquiry Portal</h1>
                    </Menu.Item>
                <Menu.Menu position="left">
                 </Menu.Menu>
                <Menu.Menu position="right">
                    <Dropdown text='Underwriting & Assign Risk' pointing className='link item'>
                        <Dropdown.Menu>
                            <Dropdown.Item as={NavLink} to={"/audit-inquiry"} content={"Audit Inquiry"}
                                onClick={(e) => dispatch({ type: "set underwriting" })}>
                            </Dropdown.Item>
                            <Dropdown.Item as={NavLink} to={"/class-inquiry"} content={"Class Inquiry"}
                                onClick={(e) => dispatch({ type: "set underwriting" })}>
                            </Dropdown.Item>
                            <Dropdown.Item as={NavLink} to={"/plan"} content={"Plan Correspondence Submission"}
                                icon={globalState.state.appState.user &&
                                    globalState.state.appState.user.profile.role_extended.includes("BureauPortal:plan_carrier") ? "unlock" : "lock"}
                                onClick={(e) => {
                                    dispatch({ type: "set plan" });
                                    dispatch({ type: "check authentication", value: "Plan Correspondence Submission"});
                                }}>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown text='Rating & Ownership' pointing className='link item'>
                        <Dropdown.Menu>
                            <Dropdown.Item as={NavLink} to={"/single-entity"} content={"Single Entity Ownership"}
                                onClick={(e) => dispatch({ type: "set ownership" })}>
                            </Dropdown.Item>
                            <Dropdown.Item as={NavLink} to={"/experience-rating"} content={"Experience Rating Inquiry"}
                                onClick={(e) => dispatch({ type: "set experienceRating" })}>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown text='Policy' pointing className='link item'>
                        <Dropdown.Menu>
                            <Dropdown.Item as={NavLink} to={"/policy-coverage"} content={"Policy Coverage Request"}
                                onClick={(e) => dispatch({ type: "set policyCoverage" })}>
                            </Dropdown.Item>
                            <Dropdown.Item as={NavLink} to={"/notice-of-election"} content={"Notice of Election"}
                                onClick={(e) => dispatch({ type: "set noticeOfElection" })}>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown text='Actuarial & Statistical' pointing className='link item'>
                        <Dropdown.Menu>
                            <Dropdown.Item as={NavLink} to={"/special-calls"} content={"Special Calls Submission"}
                                icon={globalState.state.appState.user &&
                                    globalState.state.appState.user.profile.role_extended.includes("Cafe:carrier") ? "unlock" : "lock"}
                                onClick={(e) => {
                                    dispatch({ type: "set specialCalls" });
                                    dispatch({ type: "check authentication", value: "Special Calls Submission" });
                                }}>
                            </Dropdown.Item>
                            <Dropdown.Item as={NavLink} to={"/actuarial"} content={"Actuarial Inquiry"}
                                onClick={(e) => dispatch({ type: "set actuarial" })}>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Menu.Item as={NavLink} to={"/membership"} content={"Member Carrier Inquiry"}
                        onClick={(e) => dispatch({ type: "set membership" })}>
                    </Menu.Item>
                    <Menu.Item as={Link} to={""} onClick={(e) => themeToggle(e, dispatch)}>
                            <span role="img" aria-label="Toggle Theme" >💡</span></Menu.Item>
                    </Menu.Menu>
                </Menu>
            {[props.children].map((c, i) =>
                <div key={`navbar_child_${i}`} style={{ marginTop: globalState.state.appState.isNavbarVisible ? "2em" : "1em" }}>{c}</div>)}
        </div>) ||
        <div>
            {[props.children].map((c, i) =>
                <div key={`navbar_child_${i}`} style={{ marginTop: globalState.state.appState.isNavbarVisible ? "2em" : "1em" }}>{c}</div>)}
        </div>
    );
};

export default ResponsiveNavbar;
